import React from 'react';
import { Button, Paper, Typography } from '@mui/material';

// Aviso flotante de versión nueva (useAppUpdateChecker). Flotante a propósito:
// no toca el layout (las pantallas con height 100% no pierden alto) y su zIndex
// de snackbar queda por ENCIMA de los diálogos — visible aunque haya un modal.
const UpdateBanner: React.FunctionComponent<{ onReload: () => void }> = ({ onReload }) => (
    <Paper
        elevation={6}
        sx={{
            position: 'fixed',
            bottom: 16,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: (theme) => theme.zIndex.snackbar,
            px: 2,
            py: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            borderRadius: 99
        }}
    >
        <Typography variant="body2">Hay una versión nueva de la app</Typography>
        <Button size="small" variant="contained" onClick={onReload}>
            Actualizar
        </Button>
    </Paper>
);

export default UpdateBanner;
